import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path fill="currentColor" d="M3 3h2.333v2.333H3V3Z" />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2.5 3a.5.5 0 0 1 .5-.5h2.333a.5.5 0 0 1 .5.5v2.333a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V3Zm1 .5v1.333h1.333V3.5H3.5Z"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M14.667 3H17v2.333h-2.333V3Z" />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M14.167 3a.5.5 0 0 1 .5-.5H17a.5.5 0 0 1 .5.5v2.333a.5.5 0 0 1-.5.5h-2.333a.5.5 0 0 1-.5-.5V3Zm1 .5v1.333H16.5V3.5h-1.333Z"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M14.667 14.667H17V17h-2.333v-2.333Z" />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M14.167 14.667a.5.5 0 0 1 .5-.5H17a.5.5 0 0 1 .5.5V17a.5.5 0 0 1-.5.5h-2.333a.5.5 0 0 1-.5-.5v-2.333Zm1 .5V16.5H16.5v-1.333h-1.333Z"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M3 14.667h2.333V17H3v-2.333Z" />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2.5 14.667a.5.5 0 0 1 .5-.5h2.333a.5.5 0 0 1 .5.5V17a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-2.333Zm1 .5V16.5h1.333v-1.333H3.5Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3.078 3.778a.7.7 0 0 1 .7-.7h12.444a.7.7 0 0 1 .7.7v12.444a.7.7 0 0 1-.7.7H3.778a.7.7 0 0 1-.7-.7V3.778Zm1.4.7v11.044h11.044V4.478H4.478Zm3.266 2.41a.7.7 0 0 1 .7-.7h5.445a.7.7 0 0 1 .7.7V10a.7.7 0 0 1-.7.7h-1.633v2.411a.7.7 0 0 1-.7.7H6.11a.7.7 0 0 1-.7-.7V10a.7.7 0 0 1 .7-.7h1.633V6.889Zm1.4 2.412h4.045V7.589H9.144V9.3Zm-2.333 1.4v1.711h4.045V10.7H6.81Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
